import DashboardSection from './DashboardSection'
import DashboardCard from './DashboardCard'
import DashboardHeader from './DashboardHeader'
import DashboardContainer from './DashboardContainer'
import FullScreenOverlay from './FullScreenOverlay'
import IsSyncing from './IsSyncing'
import IsEncoding from './IsEncoding'
import IsDeploying from './IsDeploying'
import ActivityTable from './ActivityTable'
export const LayoutComponents = {
    components: {
        DashboardContainer,
        DashboardCard,
        DashboardSection,
        DashboardHeader,
        FullScreenOverlay,
        IsSyncing,
        IsEncoding,
        IsDeploying,
        ActivityTable
    }
  };
  